export default function (Alpine) {

    const _openMenus = new Set();

    document.addEventListener('pointerdown', (e) => {
        _openMenus.forEach(instance => {
            if (!instance.$root.contains(e.target)) instance.close();
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') _openMenus.forEach(i => i.close());
    });

    Alpine.data('contextmenu', () => ({

        open:            false,
        _targetEl:       null,
        _placement:      null,
        _cleanup:        [],
        _longPressTimer: null,
        _longPressDur:   500,
        _focusIdx:       -1,

        init() {
            const root = this.$root;
            const self = this;

            self._placement = root.getAttribute('placement') ?? null;

            const sel = root.getAttribute('target');
            self._targetEl = sel ? document.querySelector(sel) : root.previousElementSibling;

            if (!self._targetEl) { console.warn('[contextmenu] target bulunamadı.'); return; }

            document.body.appendChild(root);
            Object.assign(root.style, { position: 'fixed', zIndex: '9999' });
            root.setAttribute('role', 'menu');

            self._initItems();
            self._bindTarget();
            self._bindKeyboard();
            self._watch();
        },

        destroy() {
            this._cleanup.forEach(({ el, type, fn }) => el.removeEventListener(type, fn));
            this._cleanup = [];
            _openMenus.delete(this);
        },


        _initItems() {
            const self = this;
            self.$root.querySelectorAll('[cm-item]:not([cm-sub] [cm-item])').forEach(item => self._bindItem(item));
            self.$root.querySelectorAll('[cm-sub-trigger]').forEach(trigger => self._bindSubTrigger(trigger));
        },

        _bindItem(item) {
            const self = this;
            item.setAttribute('role', 'menuitem');
            item.setAttribute('tabindex', '-1');
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                if (item.hasAttribute('disabled')) return;
                const value = item.getAttribute('cm-item') || item.textContent.trim();
                self.$root.dispatchEvent(new CustomEvent('cm:select', { detail: { value, item }, bubbles: true }));
                self.close();
            });
        },

        _bindSubTrigger(trigger) {
            const self   = this;
            const subId  = trigger.getAttribute('cm-sub-trigger');
            const subEl  = self.$root.querySelector(`[cm-sub="${subId}"]`);
            if (!subEl) return;

            trigger.setAttribute('role', 'menuitem');
            trigger.setAttribute('aria-haspopup', 'true');
            trigger.setAttribute('tabindex', '-1');
            subEl.setAttribute('role', 'menu');
            Object.assign(subEl.style, { position: 'absolute' });

            let subTimer = null;

            const openSub = () => {
                if (trigger.hasAttribute('disabled')) return;
                self.$root.querySelectorAll('[cm-sub]').forEach(s => { if (s !== subEl) s.removeAttribute('open'); });
                subEl.toggleAttribute('open', true);
                self._positionSub(trigger, subEl);
            };
            const closeSub = () => subEl.removeAttribute('open');

            trigger.addEventListener('mouseenter', () => { clearTimeout(subTimer); openSub(); });
            trigger.addEventListener('mouseleave', () => { subTimer = setTimeout(() => { if (!subEl.matches(':hover')) closeSub(); }, 100); });
            subEl.addEventListener('mouseleave',   () => { subTimer = setTimeout(() => { if (!trigger.matches(':hover')) closeSub(); }, 100); });
            subEl.addEventListener('mouseenter',   () => clearTimeout(subTimer));

            subEl.querySelectorAll('[cm-item]').forEach(item => {
                item.setAttribute('role', 'menuitem');
                item.setAttribute('tabindex', '-1');
                item.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (item.hasAttribute('disabled')) return;
                    const value = item.getAttribute('cm-item') || item.textContent.trim();
                    self.$root.dispatchEvent(new CustomEvent('cm:select', { detail: { value, item }, bubbles: true }));
                    self.close();
                });
            });
        },


        _bindTarget() {
            const self = this;
            const el   = self._targetEl;

            const onContextMenu = (e) => {
                e.preventDefault();
                e.stopPropagation();
                self._openAt(e.clientX, e.clientY);
            };

            const onPointerDown = (e) => {
                if (e.pointerType === 'touch') {
                    self._longPressTimer = setTimeout(() => self._openAt(e.clientX, e.clientY), self._longPressDur);
                }
            };
            const onPointerUp     = () => clearTimeout(self._longPressTimer);
            const onPointerCancel = () => clearTimeout(self._longPressTimer);

            el.addEventListener('contextmenu',   onContextMenu);
            el.addEventListener('pointerdown',   onPointerDown);
            el.addEventListener('pointerup',     onPointerUp);
            el.addEventListener('pointercancel', onPointerCancel);

            self._cleanup.push(
                { el, type: 'contextmenu',   fn: onContextMenu },
                { el, type: 'pointerdown',   fn: onPointerDown },
                { el, type: 'pointerup',     fn: onPointerUp },
                { el, type: 'pointercancel', fn: onPointerCancel },
            );
        },

        _bindKeyboard() {
            const self = this;
            const onKey = (e) => {
                if (!self.open) return;
                const items = self._activeItems();
                if (!items.length) return;

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    self._focusIdx = (self._focusIdx + 1) % items.length;
                    items[self._focusIdx]?.focus();
                }
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    self._focusIdx = (self._focusIdx - 1 + items.length) % items.length;
                    items[self._focusIdx]?.focus();
                }
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    items[self._focusIdx]?.click();
                }
                if (e.key === 'Tab') self.close();
            };

            document.addEventListener('keydown', onKey);
            self._cleanup.push({ el: document, type: 'keydown', fn: onKey });
        },

        _activeItems() {
            return [...this.$root.querySelectorAll(
                '[cm-item]:not([disabled]):not([cm-sub] [cm-item]), [cm-sub-trigger]:not([disabled])'
            )];
        },


        _openAt(mouseX, mouseY) {
            const self = this;
            _openMenus.forEach(d => { if (d !== self) d.close(); });

            // cm:opening — açılmadan hemen önce, animasyon başlamadan
            self.$root.dispatchEvent(new CustomEvent('cm:opening', {
                detail: { x: mouseX, y: mouseY },
                bubbles: true,
            }));

            self.open = true;
            self._focusIdx = -1;
            _openMenus.add(self);

            self.$nextTick(() => {
                self.$root.querySelectorAll('[cm-sub]').forEach(s => s.removeAttribute('open'));
                self._position(mouseX, mouseY);

                const dur = self._getDuration();
                self.$root.setAttribute('opening', '');
                requestAnimationFrame(() => {
                    if (dur > 0) setTimeout(() => self.$root.removeAttribute('opening'), dur);
                    else self.$root.removeAttribute('opening');
                });
            });
        },

        close() {
            if (!this.open) return;
            const self = this;
            const dur  = self._getDuration();

            _openMenus.delete(self);
            self.$root.querySelectorAll('[cm-sub]').forEach(s => s.removeAttribute('open'));

            if (dur > 0) {
                self.$root.setAttribute('closing', '');
                setTimeout(() => {
                    self.open = false;
                    self.$root.removeAttribute('closing');
                }, dur);
            } else {
                self.open = false;
            }
        },

        _getDuration() {
            const s = getComputedStyle(this.$root);
            const t = parseFloat(s.transitionDuration) || 0;
            const a = parseFloat(s.animationDuration)  || 0;
            return Math.max(t, a) * 1000;
        },


        _position(mouseX, mouseY) {
            const self     = this;
            const menu     = self.$root;
            const target   = self._targetEl;
            const placement= self._placement;
            let mW         = menu.offsetWidth  || 200;
            let mH         = menu.offsetHeight || 100;
            const vW       = window.innerWidth;
            const vH       = window.innerHeight;
            const gap      = 4;

            let left, top;

            // Önceki inner boyutlarını temizle
            if (placement !== 'inner') {
                menu.style.width  = '';
                menu.style.height = '';
            }

            if (placement) {
                // Placement modunda: target elementine göre konumlan
                const tr = target.getBoundingClientRect();
                const [primary, align] = placement.split('-');

                switch (primary) {
                    case 'top':
                        top  = tr.top - mH - gap;
                        left = tr.left;
                        break;
                    case 'bottom':
                        top  = tr.bottom + gap;
                        left = tr.left;
                        break;
                    case 'left':
                        top  = tr.top;
                        left = tr.left - mW - gap;
                        break;
                    case 'right':
                        top  = tr.top;
                        left = tr.right + gap;
                        break;
                    case 'inner':
                        // Elementin içinde — w-full h-full ile tam üstüne oturur
                        top  = tr.top;
                        left = tr.left;
                        mW   = tr.width  || mW;
                        mH   = tr.height || mH;
                        menu.style.width  = `${tr.width}px`;
                        menu.style.height = `${tr.height}px`;
                        break;
                    default: // 'center' — elementin tam ortası
                        top  = tr.top + tr.height / 2 - mH / 2;
                        left = tr.left + tr.width  / 2 - mW / 2;
                }

                // Align (yatay veya dikey hizalama)
                if (primary === 'top' || primary === 'bottom') {
                    if (align === 'center') left = tr.left + tr.width / 2 - mW / 2;
                    if (align === 'end')    left = tr.right - mW;
                } else if (primary === 'left' || primary === 'right') {
                    if (align === 'center') top = tr.top + tr.height / 2 - mH / 2;
                    if (align === 'end')    top  = tr.bottom - mH;
                }

                menu.setAttribute('data-placement', primary);
            } else {
                // Placement yok — mouse koordinatı
                left = mouseX;
                top  = mouseY;
                menu.removeAttribute('data-placement');
            }

            // Viewport sınırları
            if (left + mW > vW - gap) left = vW - mW - gap;
            if (left < gap)           left = gap;
            if (top  + mH > vH - gap) top  = vH - mH - gap;
            if (top  < gap)           top  = gap;

            menu.style.left = `${left}px`;
            menu.style.top  = `${top}px`;
        },

        _positionSub(trigger, subEl) {
            const pr  = this.$root.getBoundingClientRect();
            const mW  = subEl.offsetWidth  || 180;
            const mH  = subEl.offsetHeight || 100;
            const vW  = window.innerWidth;
            const vH  = window.innerHeight;
            const gap = 4;

            let left = trigger.offsetWidth;
            let top  = trigger.offsetTop;

            if (pr.right + mW + gap > vW) left = -mW;
            if (pr.top + top + mH > vH - gap) top = top - mH + trigger.offsetHeight;

            subEl.style.left = `${left}px`;
            subEl.style.top  = `${top}px`;
            subEl.setAttribute('data-placement', left >= 0 ? 'right' : 'left');
        },


        // Dinamik item ekleme
        addItem(value, label, options = {}) {
            const self = this;
            const item = document.createElement('div');
            item.setAttribute('cm-item', value);
            item.textContent = label;
            if (options.disabled)   item.setAttribute('disabled', '');
            if (options.group)  {
                const group = self.$root.querySelector(`[cm-group="${options.group}"]`);
                if (group) { group.after(item); return; }
            }
            self.$root.appendChild(item);
            self._bindItem(item);
        },

        removeItem(value) {
            this.$root.querySelector(`[cm-item="${value}"]`)?.remove();
        },

        addSeparator() {
            const sep = document.createElement('div');
            sep.setAttribute('cm-separator', '');
            this.$root.appendChild(sep);
        },


        _watch() {
            const self = this;
            self.$watch('open', (val) => {
                if (val) self.$root.setAttribute('open', '');
                else     self.$root.removeAttribute('open');
                self.$root.dispatchEvent(new CustomEvent(val ? 'cm:open' : 'cm:close', { bubbles: true }));
            });
        },

    }));

}

/*
<div id="myArea">Sağ tıkla</div>

<div x-data="contextmenu" target="#myArea">
  <div cm-group>Dosya</div>
  <div cm-item="open">Aç</div>
  <div cm-item="save">Kaydet</div>
  <div cm-separator></div>
  <div cm-item="delete" disabled>Sil</div>
  <div cm-sub-trigger="share">Paylaş ›</div>
  <div cm-sub="share">
    <div cm-item="copy-link">Linki Kopyala</div>
    <div cm-item="share-twitter">Twitter</div>
  </div>
</div>


PLACEMENT (mouse yerine sabit konum):

<div x-data="contextmenu" target="#myArea" placement="bottom-center">
  ...
</div>

placement değerleri:
  top | top-center | top-end
  bottom | bottom-center | bottom-end
  left | left-center | left-end
  right | right-center | right-end
  center  (elementin tam ortası)
  inner   (elementin tam üstüne oturur — w-full h-full ile tam kaplar)

placement yoksa → mouse'un olduğu yerde açılır


ATTRİBUTELER — Wrapper:
  target       CSS selector — yoksa previousElementSibling
  placement    sabit konum — yoksa mouse koordinatı

ATTRİBUTELER — İçerik:
  cm-item          tıklanabilir item
  cm-group         grup başlığı
  cm-separator     ayırıcı
  cm-sub-trigger   sub-menu açar
  cm-sub           sub-menu wrapper
  disabled         devre dışı

CSS HOOK'LARI:
  [x-data="contextmenu"][open]      açık menü
  [x-data="contextmenu"][opening]   açılıyor
  [x-data="contextmenu"][closing]   kapanıyor
  [x-data="contextmenu"][data-placement]  konum yönü
  [cm-item][disabled]               devre dışı
  [cm-sub][open]                    açık sub-menu
  [cm-sub][data-placement]          sub yönü (right/left)

EVENTLER:
  cm:opening → açılmadan hemen önce (animasyon başlamadan), e.detail: { x, y }
  cm:open    → açıldı (open attr set edildi)
  cm:close   → kapandı
  cm:select  → e.detail: { value, item }

JS API:
  const cm = el._x_dataStack[0]
  cm.close()
  cm.addItem('rename', 'Yeniden Adlandır')
  cm.addItem('copy', 'Kopyala', { disabled: true })
  cm.removeItem('rename')
  cm.addSeparator()

KLAVYE:
  ArrowDown / ArrowUp   item'lar arası gezinim
  Enter / Space         seç
  Escape                kapat
  Tab                   kapat
*/